import "../css/pInvoicePrint.css";
import { useAtom } from "jotai";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { IoCloseSharp, IoPrintSharp } from "react-icons/io5";
import { useEffect, useRef, useState } from "react";
import { pageSizes } from "../../doctor_setup/constants/_constant";
import { useItemsFilter } from "../../_helper/actions/app/items";
import moment from "moment";
import { getImageURL } from "../../_helper/utils/image";

const PInvoicePrint = ({
  invoiceData: invoice_data,
  pharmacyLines,
  closeModal,
  isPrint,
}) => {
  const [invoiceData, setInvoiceData] = useState();
  const [selectedPage, setSelectedPage] = useState("A5");
  const [doctorSettings] = useAtom(doctorSettingAtom);
  const [clinic] = useAtom(clinicAtom);
  const billPrintRef = useRef(null);
  const billType = invoiceData?.bill_type;
  const patienName = invoiceData?.patient_details?.full_name;
  const billNo = invoiceData?.invoice_no;
  const bill_type = {
    IPD: invoiceData?.admission_details?.IPD_No,
    OPD: invoice_data?.opd?.opd_number,
  };
  const DOA = `${moment(invoiceData?.admission_details?.admission_date).format(
    "DD-MMM-YYYY"
  )} at ${invoiceData?.admission_details?.admission_time}`;

  const DOD = `${moment(invoiceData?.admission_details?.discharge_date).format(
    "DD-MMM-YYYY"
  )} at ${invoiceData?.admission_details?.discharge_time}`;

  const isDOA =
    invoiceData?.admission_details?.admission_date &&
    invoiceData?.admission_details?.admission_time;

  const isDOD =
    invoiceData?.admission_details?.discharge_date &&
    invoiceData?.admission_details?.discharge_time;

  const opdTime = invoice_data?.opd?.date;
  const amountInWords = invoiceData?.amount_in_word;
  const invoiceDate = moment(invoiceData?.invoice_date).format("DD-MMM-YYYY");
  const injury_no = invoiceData?.admission_details?.injury_no;

  const { data } = useItemsFilter(
    "payments/billing/",
    `?action=getcreatePDFInvoice&clinic_id=${clinic?.id}&backend=True&invoice_data=${invoice_data?.id}`,
    clinic?.id && invoice_data?.id ? true : false
  );

  // Define the print function using the useReactToPrint hook
  const handlePrint = useReactToPrint({
    content: () => billPrintRef.current,
  });

  console.log("Invoice Data", invoiceData);

  useEffect(() => {
    if (isPrint && invoiceData) {
      handlePrint();
      closeModal();
    }
  }, [isPrint, invoiceData]);

  useEffect(() => {
    if (data?.invoiceData) {
      setInvoiceData(data?.invoiceData);
    }
  }, [data]);

  return (
    <div className="w-[14.8cm] h-[21.0cm] opacity-0">
      <div className="flex justify-end gap-3 items-center border-b pb-1 mb-1">
        <div>
          <select
            className="border"
            onChange={(e) => setSelectedPage(e.target.value)}
            value={selectedPage}
          >
            <option value={"A3"}>A3</option>
            <option value={"A4"}>A4</option>
            <option value={"A5"}>A5</option>
          </select>
        </div>
        <ReactToPrint
          trigger={() => <IoPrintSharp size={19} className="cursor-pointer" />}
          content={() => billPrintRef.current}
          pageStyle={`
          @page {
            size: ${selectedPage};
            margin: 0;
          }
          @top-left {
            content: none;
          }
          @top-center {
            content: none;
          }
          @top-right {
            content: none;
          }
          @bottom-left {
            content: none;
          }
          @bottom-center {
            content: none;
          }
          @bottom-right {
            content: none;
          }`}
          onBeforePrint={() => {
            // Apply styles to the container div before printing
            if (billPrintRef.current) {
              billPrintRef.current.style.width = `${pageSizes[selectedPage]?.width}cm`; // Example width
              // billPrintRef.current.style.height = `${pageSizes[selectedPage]?.height}cm`; // Example height
            }
          }}
          onAfterPrint={() => {
            // Reset styles after printing (optional)
            if (billPrintRef.current) {
              billPrintRef.current.style.width = "";
              // billPrintRef.current.style.height = "";
            }
          }}
        />
        <IoCloseSharp
          size={19}
          onClick={() => closeModal()}
          className="cursor-pointer"
        />
      </div>
      <div
        ref={billPrintRef}
        style={{
          // width: `${pageSizes[selectedPage]?.width}cm`,
          height: `${pageSizes[selectedPage]?.height}cm`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="cu-ph-invoice-print">
          <div className="w-full">
            <img
              src={getImageURL(
                doctorSettings?.header_footer_setup[selectedPage]?.headerUrl
              )}
              className="w-full"
            />
          </div>
          <div className="cu-ph-invoice-billing-type">
            {billType} Billing Summary
          </div>
          <div className="cu-ph-invoice-patient-details">
            <div>
              <div>{`Name: Mr. ${patienName}`}</div>
              <div>{`Bill No: ${billNo}`}</div>
              <div>{`Invoice Date: ${invoiceDate}`}</div>
            </div>
            <div>
              {injury_no && <div>{`Injury Slip No: ${injury_no}`}</div>}
              {bill_type?.IPD && <div>{`IPD No: ${bill_type?.IPD}`}</div>}
              {bill_type?.OPD && <div>{`OPD No: ${bill_type?.OPD}`}</div>}
              {isDOA && <div>{`DOA: ${DOA}`}</div>}
              {isDOD && <div>{`DOD: ${DOD}`}</div>}
              {bill_type?.OPD && <div>{`OPD Date: ${opdTime}`}</div>}
            </div>
          </div>
          <div className="cu-ph-invoice-pdf-table">
            <table>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Qty</th>
                  <th>Rate/Package</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {pharmacyLines?.map((invcSer, pkgIdx) => {
                  return (
                    <tr className="text-[13px]" key={`${""}${pkgIdx}`}>
                      <td>
                        <b>{`${invcSer?.medicine_name} `}</b>
                        {invcSer?.generic_name === "nan" ||
                        !invcSer?.generic_name ? (
                          ""
                        ) : (
                          <div className="pt-[1px] text-[12px]">
                            {invcSer?.generic_name}
                          </div>
                        )}
                        {invcSer?.batch_no?.map((ele) => {
                          if (ele?.consumed_qty > 0) {
                            return (
                              <div
                                className="text-[12px]"
                                key={ele?.batchId}
                              >{`Batch No: ${ele?.batchNo}, Qty: ${
                                ele?.consumed_qty
                              }, expiry: ${moment(ele?.expiry).format(
                                "DD MMM YYYY"
                              )}`}</div>
                            );
                          }
                        })}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid #000000cc",
                        }}
                      >
                        <div className="flex flex-col">
                          <span>{invcSer?.quantity || "-"}</span>
                        </div>
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid #000000cc",
                        }}
                      >
                        <div className="flex flex-col">
                          <span>
                            {Number(invcSer?.price) > 0 ? invcSer?.price : "-"}
                          </span>
                        </div>
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid #000000cc",
                        }}
                      >{`Rs ${invcSer?.total}`}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td style={{ fontWeight: "700" }}>Total</td>
                  <td
                    style={{
                      fontWeight: "700",
                    }}
                  >{`Rs ${invoiceData?.invoice_total}`}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-[13px]">
            <b>Total Amount in words:</b>
            {` ${amountInWords} Only.`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PInvoicePrint;
